import React from "react";
import PropTypes from "prop-types";
//
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import InputBasic from "../../../../../common/components/input/InputBasic";
import ButtonMain from "../../../../../common/components/button/ButtonMain";

const PopupCreate = ({
  context,
  title,
  inputLabel,
  onInputChange,
  hint,
  searchResult,
  submitText,
  onSubmit,
  disabledBtn,
  withGoBack,
  onGoBack,
  withNextStep,
  onNextStep,
}) => (
  <Box py={2} px={2}>
    {(withGoBack || withNextStep) && (
      <Box mb={2} display="flex" justifyContent="space-between">
        {withGoBack && (
          <IconButton
            aria-label="go back"
            onClick={(e) => onGoBack(e, context)}
          >
            <ArrowLeftIcon />
          </IconButton>
        )}
        {withNextStep && (
          <IconButton
            aria-label="go next"
            onClick={(e) => onNextStep(e, context)}
          >
            <ArrowRightIcon />
          </IconButton>
        )}
      </Box>
    )}
    {title && (
      <Box mb={2} minWidth={200}>
        <Typography variant="body2">{title}</Typography>
      </Box>
    )}
    <Box mb={2} minWidth={200}>
      {inputLabel && (
        <Box mb={2}>
          <Typography variant="body2">{inputLabel}</Typography>
        </Box>
      )}
      <Box mb={1}>
        <InputBasic
          label=""
          size="small"
          fullWidth
          onChange={(e) => {
            if (onInputChange) onInputChange(e, context);
          }}
        />
      </Box>
      <Box>{hint}</Box>
      <Box>{searchResult}</Box>
      {submitText && (
        <Box>
          <ButtonMain
            buttonProps={{
              text: submitText,
              fullWidth: true,
              onClick: (e) => {
                if (onSubmit) onSubmit(e, context);
              },
              disabled: disabledBtn,
              variant: disabledBtn ? "disabled" : null,
            }}
          />
        </Box>
      )}
    </Box>
  </Box>
);

PopupCreate.propTypes = {
  context: PropTypes.objectOf(PropTypes.any),
  title: PropTypes.string,
  submitText: PropTypes.string,
  inputLabel: PropTypes.string,
  disabledBtn: PropTypes.bool,
  onInputChange: PropTypes.func,
  onSubmit: PropTypes.func,
  hint: PropTypes.node,
  searchResult: PropTypes.node,
  withGoBack: PropTypes.bool,
  onGoBack: PropTypes.func,
  withNextStep: PropTypes.bool,
  onNextStep: PropTypes.func,
};

PopupCreate.defaultProps = {
  context: null,
  title: null,
  inputLabel: null,
  submitText: "submit",
  disabledBtn: false,
  onInputChange: () => null,
  hint: null,
  searchResult: null,
  onSubmit: () => null,
  withGoBack: false,
  onGoBack: () => null,
  withNextStep: false,
  onNextStep: () => null,
};

export default PopupCreate;
